import * as React from 'react'

import {
  SettingsPage,
  LoadingSpinner,
  ContentCentered,
} from '@sales-center/components'
import {
  useSelectCustomFieldData,
  useGetCustomFieldsOnMount,
} from '@user/store/customFields'

import { CustomFieldList } from './CustomFieldList'
import { useForm, CustomFieldForm } from './CustomFieldForm'
import { useDelete, DeleteCustomField } from './DeleteCustomField'

export function CustomFields() {
  const deleteProps = useDelete()
  const { openDelete } = deleteProps

  const { formOpen, openForm, closeForm, initialValues } = useForm()

  const loading = useGetCustomFieldsOnMount()
  const data = useSelectCustomFieldData()

  return (
    <SettingsPage title="Custom Fields" padding="40px">
      <ContentCentered>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <CustomFieldList
              {...data}
              openForm={openForm}
              openDelete={openDelete}
            />

            <CustomFieldForm
              {...data}
              open={formOpen}
              onClose={closeForm}
              initialValues={initialValues}
            />

            <DeleteCustomField {...deleteProps} />
          </>
        )}
      </ContentCentered>
    </SettingsPage>
  )
}
